import {Component, Prop, Vue} from "vue-property-decorator";
import UploaderPreviewImage from "@/components/uploader/preview-image";
import UploaderPreviewDocument from "@/components/uploader/preview-document";
import CavAbstractDocument from "@/lib/models/cav-abstract-document";

/**
 * Acts as a simple factory to build varying uploader previews types
 */
@Component
export default class UploaderPreview extends Vue{
  @Prop({default:null, type: Object }) readonly value!: CavAbstractDocument;
  render(){
    return this.value.isImage() ?
      <UploaderPreviewImage src={this.value.getUrl()} altText={this.value.file} /> :
      <UploaderPreviewDocument />;
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-4932e18b/preview.tsx" });